import SEO from '../components/SEO';
import PageLayout from '../components/PageLayout';
import GalleryGrid from '../components/GalleryGrid';
import { WHATSAPP_LINK } from '../lib/site';

const Galeria = () => {
  return (
    <PageLayout
      label="Galería"
      title="Nuestra obra,"
      titleEm="en fotos reales"
      lead="Sin fotos de stock: cada imagen es un proyecto entregado por HGO Servicios en Málaga y la Costa del Sol. Filtra por tipo de trabajo o pídenos fotos del tuyo."
      crumbs={[{ name: 'Galería' }]}
    >
      <SEO
        title="Galería de Proyectos — Reformas y Obra Nueva en Málaga"
        description="Fotos reales de proyectos de HGO Servicios: reformas integrales, obra nueva, locales comerciales, rehabilitaciones y mantenimiento en Málaga y la Costa del Sol."
        url="/galeria"
        breadcrumbs={[{ name: 'Inicio', url: '/' }, { name: 'Galería', url: '/galeria' }]}
      />

      <GalleryGrid />

      {/* CTA bajo la galería */}
      <section className="max-w-[1400px] mx-auto px-6 pb-24">
        <div className="reveal flex flex-col md:flex-row items-center justify-between gap-6 bg-paper-2 border border-line rounded-[4px] px-8 py-9">
          <div>
            <h2 className="font-display font-black uppercase tracking-tight text-2xl">
              ¿Quieres ver tu proyecto <em className="font-serifit normal-case font-normal text-clay">aquí?</em>
            </h2>
            <p className="text-ink-soft text-sm mt-2">El próximo antes/después puede ser el tuyo. Presupuesto gratis en 24h.</p>
          </div>
          <a
            href={WHATSAPP_LINK('Hola, he visto vuestra galería y me gustaría un presupuesto.')}
            target="_blank"
            rel="noopener noreferrer"
            className="btn bg-clay text-white shrink-0"
          >
            Empezar mi proyecto
          </a>
        </div>
      </section>
    </PageLayout>
  );
};

export default Galeria;
